import { useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { GiftIcon, XIcon } from 'lucide-react';
import { useExitIntent } from '../hooks/useExitIntent';
const SPECIAL_OFFER_URL = 'https://biblioteca-de-los-chakras.impultienda.ar/oferta-especial?store_id=cd36d917-d741-4af4-b918-61afcb927540';
export function ExitIntentModal() {
  const {
    closeOffer,
    isOpen
  } = useExitIntent();
  const dialogRef = useRef<HTMLDivElement>(null);
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!isOpen) return;
    closeButtonRef.current?.focus();
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        closeOffer();
        return;
      }
      if (event.key !== 'Tab' || !dialogRef.current) return;
      const focusableElements = Array.from(dialogRef.current.querySelectorAll<HTMLElement>('a[href], button:not([disabled])'));
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      if (!firstElement || !lastElement) return;
      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [closeOffer, isOpen]);
  return <AnimatePresence data-id="element-146" data-mp="1a23623sep4ot">
      {isOpen && <motion.div className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} role="presentation" data-id="element-147" data-mp="1a35wybpqb74q">
          <motion.div ref={dialogRef} role="dialog" aria-modal="true" aria-labelledby="exit-offer-title" aria-describedby="exit-offer-description" className="relative w-full max-w-md overflow-hidden rounded-[20px] border-2 border-brandViolet bg-bg-card p-6 text-center shadow-[0_0_60px_rgba(139,92,246,0.35)] md:p-8" initial={{
        opacity: 0,
        scale: 0.92,
        y: 16
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} transition={{
        type: 'spring',
        stiffness: 320,
        damping: 26
      }} data-id="element-148" data-mp="2giokh0qh1fcw">
            <div className="pointer-events-none absolute inset-x-0 top-0 h-24 bg-brandViolet/10" data-id="element-149" data-mp="zge2io7uma3j" />
            <button ref={closeButtonRef} type="button" onClick={closeOffer} className="absolute right-3 top-3 inline-flex h-9 w-9 items-center justify-center rounded-full border border-line bg-bg-highlight text-txt-muted transition-colors hover:border-brandViolet hover:text-txt-primary focus:outline-none focus:ring-2 focus:ring-brandViolet" aria-label="Cerrar oferta exclusiva" data-id="element-150" data-mp="14deaj4o9dmxa">
              <XIcon size={18} aria-hidden="true" data-id="element-151" data-mp="4692w2ajbo9c" />
            </button>

            <div className="relative mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full border border-brandViolet/40 bg-brandViolet/15 text-brandViolet shadow-[0_0_24px_rgba(139,92,246,0.25)]" data-id="element-152" data-mp="3vd26fcssvzh1">
              <GiftIcon size={28} aria-hidden="true" data-id="element-153" data-mp="3mc41msajfnxe" />
            </div>
            <p className="relative mb-2 font-sans text-[10px] font-bold uppercase tracking-[1.8px] text-brandViolet" data-id="element-154" data-mp="3megnhgjf2ifq">
              Oferta exclusiva por ahora
            </p>
            <h2 id="exit-offer-title" className="relative mb-4 font-display text-[22px] font-extrabold uppercase leading-[1.25] text-txt-primary md:text-[30px]" data-id="element-155" data-mp="3cn3wss9ctyba">
              ¡Espera! Tenemos un regalo para ti{' '}
              <span aria-hidden="true" data-id="element-156" data-mp="2ym9p6bu4s1do">🎁</span>
            </h2>
            <p id="exit-offer-description" className="relative mx-auto mb-6 max-w-sm font-sans text-[14px] leading-[1.65] text-txt-body md:text-[16px]" data-id="element-157" data-mp="2yow44wjcpj5x">
              Antes de irte, mira esta oferta exclusiva con un descuento que
              solo está disponible ahora. Pagas en tu moneda local.
            </p>

            <div className="relative flex flex-col gap-3" data-id="element-158" data-mp="xrwpw4lca7sl">
              <a href={SPECIAL_OFFER_URL} rel="noopener" className="inline-flex w-full items-center justify-center rounded-[14px] bg-brandViolet px-6 py-4 font-sans text-[15px] font-extrabold uppercase tracking-wide text-white shadow-[0_0_28px_rgba(139,92,246,0.45)] transition-all hover:-translate-y-0.5 hover:bg-brandViolet-hover hover:shadow-[0_0_42px_rgba(139,92,246,0.6)] focus:outline-none focus:ring-2 focus:ring-brandViolet focus:ring-offset-2 focus:ring-offset-bg-card" data-id="element-159" data-mp="ivnrt6d6q0hr">
                Ver oferta
              </a>
              <button type="button" onClick={closeOffer} className="inline-flex w-full items-center justify-center rounded-[14px] border border-line bg-bg-highlight px-6 py-3.5 font-sans text-[14px] font-bold text-txt-muted transition-colors hover:border-brandViolet/50 hover:text-txt-primary focus:outline-none focus:ring-2 focus:ring-brandViolet focus:ring-offset-2 focus:ring-offset-bg-card" data-id="element-160" data-mp="295r044xh6l0e">
                No, gracias
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}